import api from '@/services/api';

const HelpCenterQuery = {
  getHelpCenterUrl: () => {
    return api.get('get_help_center_url_for_lefiling/');
  }
};

export default HelpCenterQuery;
